import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

let selectedTab = ''

export const useOfferBaseModalTabs = () => {
    const [activeTab, setActiveTab] = useState(selectedTab || 'offer')
    const { t } = useTranslation()

    const tabs = useMemo(
        () => [
            { id: 1, name: 'offer', label: t('app.common.offer.title') },
            { id: 2, name: 'print', label: t('app.common.print.title') },
        ],
        [t]
    )

    const handleTabChange = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
            selectedTab = tab
        }
    }

    return {
        tabs,
        activeTab,
        handleTabChange,
    }
}
